import matchers from "@testing-library/jest-dom/matchers"
import { DropdownButton, StandardButton } from "../atoms/buttons"
import { HorizontalLayout, VerticalLayout } from "../components/layout"
import { SettingHeader } from "./SettingHeader"
import { useState } from "react"

export const ThemeStyleContent = ({setStyle,styles}) => {
    const [activeButtonStyle,setActiveButton] = useState(1)
    const [activeSideBarStyle, setActiveSideBarStyle] = useState(1)
    const [buttonStyles, setButtonStyles] = useState([{currentValue:0 ,content:"Rechthoekig", id:1, value:0},{currentValue:1, content:"Gemiddeld rond", id:2},{currentValue:2, content:"Rond", id:3}])
    const [sidebarStyles, setSidebarStyle] = useState([{currentValue:1,content:"Breed",id:1, value:0},{currentValue:2,content:"Small",id:2, value:0}])
    
    const handleSelection = (index, value) => {
        setActiveButton(value)
        const copyButtonStyles = [...buttonStyles]
       
        setStyle({"border_radius": `${copyButtonStyles.filter((row) => row.currentValue == value)[0].currentValue}`})
    }
    const handleSidebar = (index, value) => {
        setActiveSideBarStyle(value)
        const copySidebarStyles = [...sidebarStyles]
       
        setStyle({"sidebar_style": `${copySidebarStyles.filter((row) => row.currentValue == value)[0].currentValue}`})
    }

    return (
        <VerticalLayout className={"theme-create-content"} >
            <SettingHeader
            title={"Vormstijlen"}
            description={"Pas hier de vormstijlen aan"}
             />

            <StyledCards
                 title={"Kaartenstijl"} 
                 cards={buttonStyles}
                 active={activeButtonStyle}
                 handleSelection={(index,value) => handleSelection(index,value)}
                  />
            <StyledSidebars
                 title={"Sidebarstijl"} 
                 cards={sidebarStyles}
                 active={activeSideBarStyle}
                 handleSelection={(index,value) => handleSidebar(index,value)}
                  />
           

        </VerticalLayout>
    )
}

const StyledCards = ({ title, cards, handleSelection,active }) => {
    return (
        <VerticalLayout style={{margin:"1rem", width:"unset", height:"max-content"}}>
            <p className="standard-text medium-bold styled-title">
                {title}
            </p>
            <HorizontalLayout style={{gap:"0.5rem"}}>
                {cards.map((item, index) => {
                    return (
                        <StyledCard
                            selected={() => handleSelection(index, item.currentValue)}
                            key={index}
                            active={active}
                            currentValue={item.currentValue}
                            item={item}

                        />
                    )
                })}
            </HorizontalLayout>
        </VerticalLayout>
    )
}
const StyledSidebars = ({ title, cards, handleSelection,active }) => {
    return (
        <VerticalLayout style={{margin:"1rem", width:"unset", height:"max-content"}}>
            <p className="standard-text medium-bold styled-title">
                {title}
            </p>
            <HorizontalLayout style={{gap:"0.5rem"}}>
                {cards.map((item, index) => {
                    return (
                        <SideBarStyle
                            selected={() => handleSelection(index, item.currentValue)}
                            key={index}
                            active={active}
                            currentValue={item.currentValue}
                            item={item}

                        />
                    )
                })}
            </HorizontalLayout>
        </VerticalLayout>
    )
}

const StyledCard = ({ currentValue,selected,active, item }) => {
    return (


            <StandardButton onClick={selected}  textColor={active !== currentValue?"--standard-text-color":"white"} backgroundColor={currentValue == active ? "primary-600":"primary-50"} style={{width:"unset", borderColor:"--border-color ", borderWidth:"1px"}}  title={item.content}/>


    )
}
const SideBarStyle = ({ currentValue,selected,active, item }) => {
    return (


            <StandardButton onClick={selected}  textColor={active !== currentValue?"--standard-text-color":"white"} backgroundColor={currentValue == active ? "primary-600":"primary-50"} style={{width:"unset", borderColor:"--border-color ", borderWidth:"1px"}}  title={item.content}/>


    )
}